<template>
  <div class="column" :class="columnSize">
    <!-- <tags-input
      label="Tags"
      :values="value"
      :allow-new="false"
      display-all-or-any
      size="is-small"
      horizontal
      :type="active ? 'is-info' : ''"
      :custom-class="active ? 'has-text-info' : ''"
      @add="add"
      @remove="remove"
    /> -->
    <base-tag-input
      :value="value"
      :prepend="[
        { name: 'All' },
        { name: 'Any' },
      ]"
      horizontal
      size="is-small"
      :type="active ? 'is-info' : ''"
      :custom-class="active ? 'has-text-info' : ''"
      @add="add"
      @remove="remove"
    />
  </div>
</template>

<script>
import TagsInput from "@/components/partials/TagsInput";
import BaseTagInput from "@/components/partials/BaseTagInput";

export default {
  props: {
    value: {
      type: String | Array
    },
    active: {
      type: Boolean,
      default: false
    },
    columnSize: {
      type: Object | String,
      default: "is-12"
    },
    onAdd: {
      type: Function
    },
    onRemove: {
      type: Function
    }
  },
  components: {
    TagsInput,
    BaseTagInput,
  },
  methods: {
    add(tag) {
      if (this.onAdd) {
        this.onAdd(tag);
      }
    },
    remove(tag) {
      if (this.onRemove) {
        this.onRemove(tag);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/OrderFilter/Field/OrderFilterFieldTags.vue